import React from 'react'
import { Grid } from "@mui/material"
import { useSignal } from "@preact/signals-react"
import { scrollToComponent } from "@ui-seeker/utils"

import AlertsMileage from "Pages/ReportsAlerts/Alerts/Conditions/@components/MoreFeatures/Mileage"
import AlertsFuelPolicy from "Pages/ReportsAlerts/Alerts/Conditions/@components/MoreFeatures/FuelPolicy"
import AlertsAirportLocation from "Pages/ReportsAlerts/Alerts/Conditions/@components/MoreFeatures/AirportLocation"
import AlertsTransmission from "Pages/ReportsAlerts/Alerts/Conditions/@components/MoreFeatures/Transmission"
import { AppMoreOptions } from "@components"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"

export default function AlertsMoreFeatures() {

	const showOptions = useSignal(
		alertsDrawerData.peek().mileage ||
		alertsDrawerData.peek().fuelPolicy ||
		alertsDrawerData.peek().airportLocation ||
		alertsDrawerData.peek().transmission
	)

	return <AppMoreOptions
		open={showOptions.value}
		label="More features"
		onToggle={() => {
			showOptions.value = !showOptions.value
			setTimeout(() => {
				scrollToComponent("scrollToFeatures")
			}, 100)
		}}
	>
		<Grid container spacing={2}>
			<Grid item xs={6}>
				<AlertsMileage/>
			</Grid>
			<Grid item xs={6}>
				<AlertsFuelPolicy/>
			</Grid>
			<Grid item xs={6}>
				<AlertsAirportLocation/>
			</Grid>
			<Grid item xs={6}>
				<AlertsTransmission/>
			</Grid>
			<Grid item xs={12} id="scrollToFeatures"/>
		</Grid>
	</AppMoreOptions>
}
